import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '../../context/subscriptionContext';
import BrandLoadingSpinner from '../ui/BrandLoadingSpinner';

/**
 * Route-level protection component that checks subscription access before allowing navigation
 * Redirects to dashboard if user doesn't have access to the requested page
 */
const SubscriptionProtectedRoute = ({ children, requiredPage, redirectTo = "/dashboard" }) => {
  const { canAccessPage, loading, plan } = useSubscription();

  // Show loading spinner while subscription status is being determined
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <BrandLoadingSpinner message="Verifying access..." />
      </div>
    );
  }

  // Check if user has access to the required page
  const hasAccess = canAccessPage(requiredPage);

  // If user doesn't have access, redirect to allowed page
  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  // User has access, render the children
  return <>{children}</>;
};

export default SubscriptionProtectedRoute;
